// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"bd4a0c3d","646":"73f47f25","857":"ec91a35d"}[chunkId] + ".chunk.js";
};